export const VERSION = 100;
export const VERSION_WEB = "1.1.2";
export const VERSION_DATE = "08/02/2022, 05:07";
export const VERSION_CONTENT = [
  `MP-2077 [CS Tool] Lỗi không đặt được chuyên khoa nhi luồng bác sĩ UMC1`,
  "CSTOOL-178: Rà soát kiểm tra lại luồng Gỡ filter check ở mode CSKH. bv Da Liễu",
  "MP-2164: Lỗi chưa trả về response key totalMessageExtra và totalPaymentMessage trong phiếu khám Thanh toán tại cơ sở ở CS page"
];
